import React from 'react';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';

const HandlePagination = ({ pageCount, currentPage, onPageChange, className = '' }) => {
  const handlePageClick = (page) => {
    if (page >= 0 && page < pageCount) {
      onPageChange(page);
    }
  };

  const renderPageNumbers = () => {
    const pages = [];
    const maxVisiblePages = 5;
    let startPage = Math.max(0, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = startPage + maxVisiblePages - 1;

    if (endPage >= pageCount - 1) {
      endPage = pageCount - 1;
      startPage = Math.max(0, endPage - maxVisiblePages + 1);
    }

    // Previous button
    pages.push(
      <button
        key="prev"
        onClick={() => handlePageClick(currentPage - 1)}
        disabled={currentPage === 0}
        className="w-10 h-10 flex items-center justify-center rounded-full text-gray-500 hover:bg-gray-100 disabled:opacity-30 disabled:cursor-not-allowed"
        aria-label="Previous page"
      >
        <FiChevronLeft className="w-5 h-5" />
      </button>
    );

    // First page
    if (startPage > 0) {
      pages.push(
        <button
          key={0}
          onClick={() => handlePageClick(0)}
          className={`w-10 h-10 flex items-center justify-center rounded-full ${currentPage === 0 ? 'bg-blue-600 text-white' : 'text-gray-700 hover:bg-gray-100'}`}
        >
          1
        </button>
      );
      
      if (startPage > 1) {
        pages.push(
          <span key="start-ellipsis" className="w-10 h-10 flex items-center justify-center text-gray-500">
            ...
          </span>
        );
      }
    }


    // Page numbers
    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <button
          key={i}
          onClick={() => handlePageClick(i)}
          className={`w-10 h-10 flex items-center justify-center rounded-md ${currentPage === i ? 'bg-gray-600 text-white' : 'text-gray-700 hover:bg-gray-100'}`}
          aria-current={currentPage === i ? 'page' : undefined}
        >
          {i + 1}
        </button>
      );
    }


    // Last page
    if (endPage < pageCount - 1) {
      if (endPage < pageCount - 2) {
        pages.push(
          <span key="end-ellipsis" className="w-10 h-10 flex items-center justify-center text-gray-500">
            ...
          </span>
        );
      }
      
      pages.push(
        <button
          key={pageCount - 1}
          onClick={() => handlePageClick(pageCount - 1)}
          className={`w-10 h-10 flex items-center justify-center rounded-full ${currentPage === pageCount - 1 ? 'bg-blue-600 text-white' : 'text-gray-700 hover:bg-gray-100'}`}
        >
          {pageCount}
        </button>
      );
    }

    // Next button
    pages.push(
      <button
        key="next"
        onClick={() => handlePageClick(currentPage + 1)}
        disabled={currentPage >= pageCount - 1}
        className="w-10 h-10 flex items-center justify-center rounded-full text-gray-500 hover:bg-gray-100 disabled:opacity-30 disabled:cursor-not-allowed"
        aria-label="Next page"
      >
        <FiChevronRight className="w-5 h-5" />
      </button>
    );

    return pages;
  };

  if (pageCount <= 1) return null;

  return (
    <div className={`flex items-center justify-center space-x-1 ${className}`}>
      {renderPageNumbers()}
    </div>
  );
};

export default HandlePagination;
